import TabButtons from 'pages/components/tabNavigation/TabButtons';

import {
  BackMainMessage,
  BackMessage,
  BackMessage2,
  BackPermissions,
  ChatWrapper,
  TabButton1,
} from './Chat.styles';
import ByRole from './byRole';
import ByTeam from './byTeam';
import ByUser from './byUser';
import { RowIcon } from './components/rowIcon';
import { useChatSearchParams } from './useSearchData';

const Chat = () => {
  const tabs = [{ name: 'By Role' }, { name: 'By User' }, { name: 'By Team' }];
  const { searchData, setChatSearchData } = useChatSearchParams();
  const changeTab = (tabValue) => {
    setChatSearchData({ section: tabValue, offset: 0, limit: 10 });
  };

  const colors = [{ bg: 'linear-gradient(135deg, #2A76E9 0%, #20457B 100%)', color: 'white' }];
  return (
    <ChatWrapper>
      <BackPermissions>
        <RowIcon size={56} color={colors[0]} />
        <BackMainMessage>
          <BackMessage>Configure permissions for unified messaging</BackMessage>
          <BackMessage2>Unified Communication access</BackMessage2>
        </BackMainMessage>
      </BackPermissions>

      <TabButton1>
        <TabButtons
          tabs={tabs}
          activeTab={searchData.section || 'By Role'}
          onTabChange={(tabValue) => changeTab(tabValue)}
        />
      </TabButton1>

      {(searchData.section === 'By Role' || !searchData.section) && <ByRole />}
      {searchData.section === 'By User' && <ByUser />}
      {searchData.section === 'By Team' && <ByTeam />}
    </ChatWrapper>
  );
};

export default Chat;
